import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import styles from "./LandingPromoTeaser.module.css";
import PromoCard from "../../promociones/PromoCard";
import usePromotions from "../../promociones/usePromotions";
import { Stagger, StaggerItem } from "../../../../components/motion";

const TEASER_LIMIT = 3;

/**
 * Promociones activas en el home. Se oculta mientras carga, si no hay promociones
 * activas o si el API falla. Con el módulo de rifas apagado (`feature_disabled`) el
 * backend sigue devolviendo las promociones informativas (PROMO_INFO) y se muestran.
 * @param {object} props
 * @param {object} [props.reveal]
 * @param {function} [props.sectionReveal]
 */
const LandingPromoTeaser = ({ reveal, sectionReveal }) => {
  const { promotions, loading } = usePromotions({ status: "active" });
  const items = promotions.slice(0, TEASER_LIMIT);
  const hidden = loading || items.length === 0;

  const sectionClass =
    sectionReveal && reveal ? `${styles.section} ${sectionReveal(reveal)}` : styles.section;

  return (
    <section
      ref={reveal?.ref}
      className={sectionClass}
      id="promociones"
      aria-labelledby="landing-promos-title"
      hidden={hidden}
    >
      <div className={styles.inner}>
        <div className={styles.head}>
          <div>
            <p className={styles.eyebrow}>Promociones</p>
            <h2 id="landing-promos-title" className={styles.title}>
              Promociones exclusivas para ti
            </h2>
          </div>
          <Link to="/promociones" className={styles.allLink}>
            Ver todas las promociones
            <FontAwesomeIcon icon={faArrowRight} />
          </Link>
        </div>
        <Stagger className={`${styles.grid} ${items.length < 3 ? styles.gridCompact : ""}`}>
          {items.map((promo) => (
            <StaggerItem key={promo.slug} className="motion-fill">
              <PromoCard promo={promo} headingLevel="h3" />
            </StaggerItem>
          ))}
        </Stagger>
      </div>
    </section>
  );
};

export default LandingPromoTeaser;
